import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "../styles/client.css";
import Header from "../components/client/common/Header.js";
import Home from "../pages/Client/Home.js";
import About from "../pages/Client/About";
import Contact from "../pages/Client/Contact";
import Teacher from "../pages/Client/Teacher";
import Products from "../pages/Client/Products";
import News from "../pages/Client/News";
import Footer from "../components/client/common/Footer";
import TopBar from "../components/client/common/TopBar";
import Calender from "../pages/Client/Calender";
import PrivacyPolicy from "../pages/Client/PrivacyPolicy";
import TermsConditions from "../pages/Client/TermsConditions";
import Login from "../pages/auth/Login.js";
import { ToastContainer } from "react-toastify";
import BlogView from "../components/client/Blogs/BlogView.js";
import Blogs from "../pages/Client/Blogs.js";
import ParticulerCourse from "../pages/Client/ParticulerCourse.js";
import NewStudentForm from "../components/common/NewStudentForm.js";

function Auth({ handleLogin }) {
  const hideLayout = window.location.pathname === "/sms/newStudentForm";

  useEffect(() => {
      const hideButton = () => {
        const buttons = document.querySelectorAll(
          ".MuiButton-containedPrimary"
        );
        buttons.forEach((button) => {
          if(hideLayout){
          button.style.display = "none";
          }else{
          button.style.display = "flex";
          }
        });
      };
      hideButton();
  }, [hideLayout]);

  return (
    <BrowserRouter basename="/sms">
      <ToastContainer position="top-center" />
      {/* render only if not hidden */}
      {!hideLayout && <TopBar />}
      {!hideLayout && <Header />}
      <Routes>
        <Route path="/login" element={<Login onLogin={handleLogin} />} />
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/teachers" element={<Teacher />} />
        <Route path="/products" element={<Products />} />
        <Route path="/news" element={<News />} />
        <Route path="/calender/:id" element={<Calender />} />
        <Route path="/courses/:id" element={<ParticulerCourse />} />
        {/* <Route path="/course/chinesh" element={<ChineshCourse />} /> */}
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/terms&conditions" element={<TermsConditions />} />
        <Route path="/blog" element={<Blogs />} />
        <Route path="/blog/view/:id" element={<BlogView />} />
        <Route path="/newStudentForm" element={<NewStudentForm />} />
        <Route path="*" element={<Login onLogin={handleLogin} />} />
      </Routes>
      {/* render only if not hidden */}
      {!hideLayout && <Footer />}
    </BrowserRouter>
  );
}

export default Auth;
